export const loadTopPosts = (count) => ({
    type: "LOAD_TOP_POSTS_REQUEST",
    count
})

export const loadTopPostsSuccess = (posts) => ({
    type: "LOAD_TOP_POSTS_SUCCESS",
    posts
});

export const loadTopPostsFailed = (error) => ({
    type: "LOAD_TOP_POSTS_FAILED",
    error
});


// WEBPACK FOOTER //
// ./src/scenes/LandingPage/actions.js